<div matTooltip="Expand Case View" (click)="uiService.isCaseViewMinimized = !uiService.isCaseViewMinimized"
  class="case-view-collapsed" *ngIf="!isLoading && uiService.isCaseViewMinimized" data-cy="case-view-collapsed">
  <div style="display: flex; flex-direction: column;" data-cy="case-view-collapsed-container">
    <mat-icon data-cy="case-view-collapsed-chevron">chevron_right</mat-icon>
    <div style="color: var(--tdo-primary-accent);" data-cy="case-view-collapsed-icon"><mat-icon>assignment</mat-icon></div>
    <div style="transform: rotate(-90deg); font-size: 10px; line-height: 1; font-weight: 500;" data-cy="case-view-collapsed-text">CASE VIEW</div>
  </div>
</div> 
<div *ngIf="!uiService.isCaseViewMinimized"
  style="width: 332px; display: flex; flex-direction: column; height: 100%;" data-cy="case-view-expanded">
  <div style="flex-basis: 56px; min-height: 56px; display: flex; flex-direction: column;" data-cy="case-view-header">
    <div style="display: flex; flex-basis: fit-content;" data-cy="case-view-title-bar">
      <div style="cursor: pointer; position: relative; right: 0; color: black; font-weight: 500;"
        (click)="uiService.isCaseViewMinimized = !uiService.isCaseViewMinimized" data-cy="case-view-collapse-btn">
        <mat-icon matTooltip="Collapse Case View">chevron_left</mat-icon>
      </div>
      <div style="margin-left: 8px;" data-cy="case-view-title"><b>Case View</b></div>
    </div>
    <div style="display: flex;" *ngIf="isCanEdit()" id="case-button-container" data-cy="case-view-actions">
      <button style="position: relative; top: 1px;" mat-icon-button color="primary" (click)="openDialogAddForm()"
        [disabled]="currentSectionSelection === 1 && !currentCaseWorkItemID" data-cy="case-view-add-form-btn">
        <mat-icon matTooltip="Add Form">feed</mat-icon>
      </button>
      <button mat-icon-button color="primary" (click)="openDialogAddProcedure('ap')"
        [disabled]="currentSectionSelection === 0" data-cy="case-view-add-procedure-btn">
        <mat-icon matTooltip="Add Procedure">medical_services</mat-icon>
      </button>
      <button mat-icon-button color="primary" [disabled]="!this.allowToothPicker" (click)="openDialogEditTeeth()" data-cy="case-view-edit-teeth-btn">
        <img style="width:23px" src="assets/Images/Calendar/iconToothNew.svg">
      </button>
      <button [disabled]="!currentCaseWorkItemID && !currentCaseWorkItemFormID" mat-icon-button
        style="color: var(--tdo-secondary); position: relative; top: 1px;" (click)="openDialogRemove()" data-cy="case-view-remove-btn">
        <mat-icon matTooltip="Remove">cancel</mat-icon>
      </button>
      <!--<button mat-icon-button style="color: var(--tdo-secondary);" (click)="openPerioCharting()">
        <mat-icon matTooltip="Perio Charting">show_chart</mat-icon>
      </button>!-->
      <div style="flex: 1;"></div>
      <div style="cursor: pointer; margin-top: 8px; color: var(--tdo-primary-accent);" (click)="isShowPatientForms = !isShowPatientForms" data-cy="case-view-patient-icon">
        <mat-icon>person</mat-icon>
      </div>
      <div style="position: relative;" data-cy="case-view-visibility-container">
        <div matTooltip="Hide patient forms" *ngIf="isShowPatientForms"
          (click)="isShowPatientForms = !isShowPatientForms"
          style="position: absolute; left: -15px; cursor: pointer; margin-top: 6px; transform: scale(0.75, 0.75); color: var(--tdo-secondary);" 
          data-cy="case-view-hide-patient-forms-btn">
          <mat-icon>visibility</mat-icon>
        </div>
        <div matTooltip="Show patient forms" *ngIf="!isShowPatientForms"
          (click)="isShowPatientForms = !isShowPatientForms"
          style="position: absolute; left: -15px; cursor: pointer; margin-top: 6px; transform: scale(0.75, 0.75); color: var(--tdo-secondary);" 
          data-cy="case-view-show-patient-forms-btn">
          <mat-icon>visibility_off</mat-icon>
        </div>
      </div>
      <button mat-icon-button color="primary" id="link1" style="position: relative;" (click)="toggleMoreContent()" data-cy="case-view-more-options-btn">
        <mat-icon matTooltip="More Options">more_vert</mat-icon>
      </button>

      <dx-popover target="#case-button-container" position="right" [width]="300" [showTitle]="true" title="Case Actions"
        [(visible)]="showMoreCaseOptions" data-cy="case-view-more-options-popover">
        <div *dxTemplate="let data = model of 'content'" data-cy="case-view-more-options-content">
          <dx-list [dataSource]="listOfMoreCaseOptions" itemTemplate="listItem" data-cy="case-view-more-options-list">
            <div *dxTemplate="let caseOption of 'listItem'" (click)="processMoreOptionsEvent(caseOption.id)" data-cy="case-view-more-option-item">
              {{ caseOption.name }}
            </div>
          </dx-list>
        </div>
      </dx-popover>
    </div>
  </div>
  <div *ngIf="isShowPatientForms" style="flex-basis: 8px;"></div>
  <div *ngIf="isShowPatientForms" style="flex-basis: 230px; overflow-y: auto;" data-cy="case-view-patient-forms-container">
    <!--PATIENT FORMS MAIN-->
    <div style="height: 100%; width: 100%; display: flex; flex-direction: column; overflow-y: hidden;"
      (click)="this.currentSectionSelection = 0; this.currentCaseWorkItemID = this.caseWorkItemsPatientFormsCaseWorkItem?.CaseWorkItemId"
      [ngClass]="{'section_highlight' : this.currentSectionSelection === 0, 'section_no_highlight' : this.currentSectionSelection === 1}" 
      data-cy="case-view-patient-forms-section">
      <div
        style="width: 100%; flex-basis: fit-content; display: flex; position: relative; color: var(--tdo-secondary);" data-cy="case-view-patient-forms-header">
        <div class="header_item_cell" style="width: 60%;" data-cy="case-view-patient-forms-title">Patient Forms</div>
        <div class="header_item_cell item_cell_width_pct_15" data-cy="case-view-patient-forms-status-header">Status</div>
        <div class="header_item_cell item_cell_width_pct_25"></div>
        <div class="header_item_cell item_cell_width_pct_15" style="padding-right: 5px"></div>
        <div (click)="onPatientFormsDetails()"
          style="position: absolute; right: 5px; top: 9px; color: var(--tdo-secondary); cursor: pointer;" data-cy="case-view-patient-forms-details-btn">
          <mat-icon>feed</mat-icon>
        </div>
      </div>
      <mat-progress-bar *ngIf="isLoadingPatientForms" mode="indeterminate" data-cy="case-view-patient-forms-loading"></mat-progress-bar>
      <div *ngIf="!isLoadingPatientForms && caseWorkItemsPatientForms.length <= 0" style="width: 100%; text-align: center;" data-cy="case-view-patient-forms-empty">
        No general forms added.
      </div>
      <div *ngIf="!isLoadingPatientForms && caseWorkItemsPatientForms.length > 0" style="overflow-y: auto; flex: 1; width: 100%;" data-cy="case-view-patient-forms-list">
        <div *ngFor="let form of caseWorkItemsPatientForms; let f = index" data-cy="case-view-patient-form-item">
          <div
            (click)="onFormHeaderClick(form);"
            [ngClass]="{'form-selected' : this.isCurrentSelection('', form.CaseWorkItemFormsId)}" data-cy="case-view-patient-form-row">
            <table style="width:100%" data-cy="case-view-patient-form-table">
              <tr class="row_form" style="display: flex;">
                <td class="item_cell cursorPointer" style="padding-left: 10px; width: 60%;" data-cy="case-view-patient-form-description">
                  <div>{{ form.Description }}</div>
                </td>
                <td class="item_cell item_cell_width_pct_15 cursorPointer" style="margin-right: 5px;" data-cy="case-view-patient-form-date">
                  {{ form.StatusOn | date:'shortDate' }}
                </td>
                <td class="item_cell item_cell_width_pct_25 cursorPointer" style="font-weight: 500; padding-left: 8px;" data-cy="case-view-patient-form-status">
                  {{ getFormEnumStatus(form.enumFormCompletionStatusID) }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="flex-basis: 8px;"></div>
  <div style="flex: 1; overflow-y: hidden; display: flex; flex-direction: column;" data-cy="case-view-procedures-container">
    <div style="flex-basis: fit-content; display: flex; flex-direction: column; overflow-y: hidden;"
      (click)="this.currentSectionSelection = 1; this.currentCaseWorkItemFormID = null; this.currentCaseWorkItemID = null;"
      [ngClass]="{'section_highlight' : this.currentSectionSelection === 1, 'section_no_highlight' : this.currentSectionSelection === 0}" 
      data-cy="case-view-procedures-header">
      <div style="width:100%; display: flex;" data-cy="case-view-procedures-header-row">
        <div class="header_item_cell item_cell_width_pct_50" data-cy="case-view-procedures-title">Procedure / Forms</div>
        <div class="header_item_cell item_cell_width_pct_15" data-cy="case-view-procedures-teeth-header">Teeth</div>
        <div class="header_item_cell item_cell_width_pct_15" data-cy="case-view-procedures-date-header">Date</div>
        <div class="header_item_cell item_cell_width_pct_20" data-cy="case-view-procedures-status-header">Status</div>
      </div>
      <mat-progress-bar *ngIf="isLoading || isLoadingPatientForms" mode="indeterminate" data-cy="case-view-procedures-loading"></mat-progress-bar>
    </div>
    <div style="flex: 1; overflow-y: auto;" *ngIf="!isLoadingPatientForms && !isLoading" data-cy="case-view-procedures-list">
      <div *ngFor="let caseWorkItem of caseWorkItems; let i = index" style="flex: 1;" data-cy="case-view-procedure-item">
        <div (click)="onClickCaseWorkItem(caseWorkItem);"
          [ngClass]="{'procedure-selected' : this.isCurrentSelection(caseWorkItem.CaseWorkItemId, ''), 'row-procedure': !this.isCurrentSelection(caseWorkItem.CaseWorkItemId, '')}" 
          data-cy="case-view-procedure-row">
          <table style="width:100%; padding:0px; margin:0px" data-cy="case-view-procedure-table">
            <tr style="background-color: unset;">
              <td class="item_cell item_cell_width_pct_50"
                style="font-weight: bold; padding-bottom: 0px !important; margin-bottom: 0px !important;" data-cy="case-view-procedure-description">{{
                  caseWorkItem.Description }}</td>
              <td class="item_cell item_cell_width_pct_15" data-cy="case-view-procedure-teeth">{{ this.returnToothList(caseWorkItem.dataPatientCaseItemTeeth) }}
              </td>
              <td class="item_cell item_cell_width_pct_15" data-cy="case-view-procedure-date">{{ caseWorkItem.StatusOn | date:'shortDate' }}</td>
              <td class="item_cell item_cell_width_pct_20" data-cy="case-view-procedure-status">
                <div style="width: 100%; text-align: center; font-size: 20px; margin-top: 4px;"
                  class="material-icons-outlined"
                  [matTooltip]="this.returnCaseStatusIcon(caseWorkItem.enumCaseWorkItemStatusID, 0)" 
                  data-cy="case-view-procedure-status-icon">
                  {{ this.returnCaseStatusIcon(caseWorkItem.enumCaseWorkItemStatusID, 1) }}
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="4" class="item_cell" style="padding-top: 0px !important; margin-top: 0px !important;" data-cy="case-view-procedure-controls">
                <div style="display: flex; align-items: center; justify-content: center; height:25px" data-cy="case-view-procedure-timer-container">
                  <div style="flex-basis: 50px" data-cy="case-view-procedure-timer-buttons">
                    <button [style]="'width: 30px;height:35px'" *ngIf="!caseWorkItem.EventDateStart && isCanEdit()"
                      mat-icon-button matTooltip="Start Timer"
                      (click)="timerAction(caseWorkItem.WorkItemEventID, caseWorkItem.CaseWorkItemId, caseWorkItem.LOCID, true, false)" 
                      data-cy="case-view-procedure-start-timer">
                      <mat-icon style="color:green">play_circle</mat-icon>
                    </button>
                    <button [style]="'width: 30px;height:35px'" *ngIf="caseWorkItem.EventDateStart && isCanEdit()"
                      mat-icon-button matTooltip="Stop Timer"
                      (click)="timerAction(caseWorkItem.WorkItemEventID, caseWorkItem.CaseWorkItemId, caseWorkItem.LOCID, false, true)" 
                      data-cy="case-view-procedure-stop-timer">
                      <mat-icon style="color:red">stop_circle</mat-icon>
                    </button>
                  </div>
                  <div style="flex: 1; height: 26px;" data-cy="case-view-procedure-doctor-container">
                    <div
                      style="padding: 1px 4px 6px 4px; width: 260px; height: 100%; border-radius: 6px; border: 1px solid var(--tdo-secondary-accent); background-color: white;" 
                      data-cy="case-view-procedure-doctor-dropdown-container">
                      <label *ngIf="locationDoctors && locationDoctors.length < 1" data-cy="case-view-procedure-no-doctors">No Location Doctors Found.</label>
                      <tdo-dropdown-v2 *ngIf="locationDoctors.length > 0 && isCanEdit()" [datasource]="locationDoctors" isHideUnderline="true"
                                       [value]="caseWorkItem.ProviderDoctor"
                                       displayProperty="FullName" placeholder="Doctor" placeholderPosition="below"
                                       [isPreventMouseEventPropagation]="true"
                                       (selectionChange)="timerDoctorAction(caseWorkItem.WorkItemEventID, caseWorkItem.CaseWorkItemId, $event)" class="case-dropdown" 
                                       data-cy="case-view-procedure-doctor-dropdown">
                      </tdo-dropdown-v2>
                    </div>
                  </div>
                  <div (click)="onShowAllEventsForWorkItem(caseWorkItem)" matTooltip="See all events for this item."
                    style="flex-basis: fit-content; color: var(--tdo-secondary-accent); margin-left: 2px; cursor: pointer;" 
                    data-cy="case-view-procedure-events-btn">
                    <mat-icon>more_horiz</mat-icon>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div *ngFor="let form of caseWorkItem.dataPatientCaseItemForms; let f = index" data-cy="case-view-form-item">
          <div (click)="onFormItemClick(form, caseWorkItem);"
            [ngClass]="{'item-selected' : this.isCurrentSelection('', form.CaseWorkItemFormsId)}" data-cy="patient-case-form" style="cursor: pointer;">
            <table style="width:100%" data-cy="case-view-form-table">
              <tr class="row_form">
                <td class="item_cell form_item_cell item_cell_width_pct_50" style="padding-left: 10px" data-cy="case-view-form-description-cell">
                  <table style="width:100%;" data-cy="case-view-form-inner-table">
                    <tr>
                      <td style="width:10%;" data-cy="case-view-form-icon-cell">
                        <span style="position: relative; left: -10px;"
                          matTooltip="{{form.formFilledTooltip}}" data-cy="case-view-form-icon">
                          <img style="width:20px;" src="assets/Images/Calendar/{{form.formFilledIcon}}">
                        </span>
                      </td>
                      <td data-cy="case-view-form-description">{{ form.Description }}</td>
                    </tr>
                  </table>
                </td>
                <td class="item_cell item_cell_width_pct_15" data-cy="case-view-form-teeth">{{
                  this.returnToothListForForm(form.dataPatientCaseItemFormTeeth) }}</td>
                <td class="item_cell item_cell_width_pct_15" data-cy="case-view-form-date">{{ form.StatusOn | date:'shortDate' }}</td>
                <td class="item_cell item_cell_width_pct_20" data-cy="case-view-form-status">
                  <div
                    style="width: 25px; text-align: center; background-color: white; padding: 2px; border-radius: 50%;"
                    [matTooltip]="this.returnFormCompletionStatusByIcon(form, 0)" data-cy="case-view-form-status-icon">
                    <img style="width: 100%" [src]="this.returnFormCompletionStatusByIcon(form, 1)">
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>